import modeType from './modeType'

const state = {
  syncscroll: true,
  currentMode: modeType.view
}

export default state
